import React from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { useUpdateRestaurantMutation } from '@/api/hooks/useRestaurant';
import { RestaurantResponse } from '@/api/lib/restaurant';

import { TextInput } from '@/components/forms/base/TextInput';
import { Form } from '@/components/forms/core/Form';
import { Button } from '@/components/molecules/Button';

import { Typography } from '@/components/atoms/Typography';
import { TbMail, TbPhone } from 'react-icons/tb';
import { UpdateRestaurantSchemaType, validationSchema } from '../RestaurantForm/schema';

export interface UserFormProps {
  restaurant?: RestaurantResponse;
}

export const UserForm = ({ restaurant }: UserFormProps) => {
  const { t } = useTranslation();

  const { isLoading, mutateAsync: updateRestaurant } = useUpdateRestaurantMutation({
    onSuccess: () => {
      toast.success(t('action.restaurantUpdated'), {
        position: 'bottom-right'
      });
    }
  });

  const handleSubmit = async (data: UpdateRestaurantSchemaType) => {
    console.log(data);
    if (!restaurant?.id) {
      toast.error(t('proposeRestaurant.pleaseSelectRestaurant'), {
        position: 'bottom-right'
      });
      return;
    }

    await updateRestaurant({ ...data, restaurantId: restaurant?.id });
  };

  return (
    <div className="gap-4 flex flex-col w-full">
      <Form
        data-testid="restaurant-form"
        schema={validationSchema(t)}
        logErrors
        onSubmit={handleSubmit}
        className="flex flex-col gap-5"
        defaultValues={{
          phoneNumberOwner: restaurant?.phoneNumberOwner
        }}
        onlyTouchedFields={false}
        render={({ formState }) => {
          return (
            <>
              <div className="grid md:grid-cols-2 gap-x-2 md:gap-x-12 text-black relative">
                <TextInput id="phoneNumberOwner" leftIcon={<TbPhone />} label={t('form.phoneNumber')} placeholder={t('form.phoneNumberPlaceholder')} />
                <span>
                  <TextInput
                    id="emailAddress"
                    leftIcon={<TbMail />}
                    required
                    defaultValue={restaurant?.emailOwner}
                    disabled
                    readOnly
                    label={t('form.emailAddress')}
                    placeholder={t('form.emailAddressPlaceholder')}
                  />
                  <a href="mailto:salam@mon-resto-halal.com" className="hover:underline ">
                    <Typography variant="h5" color="gray">
                      Pour modifier votre e-mail, veuillez contacter notre support.
                    </Typography>
                  </a>
                </span>
              </div>

              <div>
                <Button fullWidth type="submit" color="primary" label={t('form.save')} loading={isLoading} disabled={!formState.isDirty} />
              </div>
            </>
          );
        }}
      />
    </div>
  );
};
